<template>
  <div class="px-3 md:px-0">
    <h1 class="text-lg font-bold">Exámenes</h1>
    <div class="text-neutral-700 mt-5 space-y-4">
      <p>
        Durante el examen, podrás revisar cada uno de los ejercicios antes de
        responder si así lo deseas. Recuerda que el propósito del examen es
        evaluar tu nivel de dominio del curso y proporcionarte la oportunidad
        para demostrar tus habilidades. Prepárate de manera adecuada, confía en
        tus conocimientos y aborda el examen con calma y confianza. ¡Mucho éxito
        en tu examen!
      </p>
    </div>

    <MobList :items="items" class="mt-5" />
  </div>
</template>

<script>
import { MobList } from "@/views/V2/components";
import {getStudentStatusExam} from "@/services/exams.service";
import {hasPassedDate} from "@/Utils/utils";

export default {
  name: "ExamIntro",
  components: {
    MobList,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  watch: {
    course: {
      immediate: true,  // dispara también al montar
      async handler(newCourse) {
        if (newCourse.id == null) return;
        
        let courseId = this.$route.params.id;
        if (courseId) {
          let exams = await getStudentStatusExam(courseId);

          for (const element of exams) {
            let currentState = '';
            let  link = element.id.toString();

            if (!this.course.enrolled) {
              currentState = 'disabled';
              link = `/course/${courseId}/exams`;
            } else if (element.finished) {
              currentState = 'completed';
              link = `/course/${courseId}/exams/${element.id.toString()}/results`;
            } else if (!hasPassedDate(element.startDate) || hasPassedDate(element.endDate)) {
              currentState = 'disabled';
              link = `/course/${courseId}/exams`;
            }
            this.items.push(
              {
                label: element.title,
                icon: "iconamoon:eye-light",
                link: link,
                state: currentState,
                isPremium: element.isPremium
              },
            )
          }
        }
      }
    }
  },
};
</script>
